<template src="./Commercial.html"></template>

<script>
import ArrobaMedellinArrobitaNoData from "@/components/ArrobaMedellinArrobitaNoData/ArrobaMedellinArrobitaNoData";
import ArrobaMedellinLogo from "@/components/Icons/ArrobaMedellinLogo";
import tutorial from "@/mixins/tutorial";
import commercialService from "@/services/Commercial/Commercial";
import { roleName } from "@/utils/constants";
import { mapGetters } from "vuex";

export default {
  name: "home",
  mixins: [tutorial],
  components: { ArrobaMedellinLogo, ArrobaMedellinArrobitaNoData },
  data() {
    return {
      userRole: null,
      roles: roleName,
      repeat: false,
      iconSize: "is-medium",
      games: {
        data: [
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/arrobamedellin.appspot.com/o/imageGames%2Fmanejodelainformaci%C3%B3n.png?alt=media&token=19301681-0679-4f56-a4d6-6d137208b34b",
            descriptionImage: "Imagen juego de Comunicación asertiva",
            title: "Conversando",
            paragraph:
              "Debate con tus amigos sobre las noticias de actualidad en el mundo.",
            lesson:
              "Maneja información con las personas de tu entorno teniendo una comunicación efectiva.",
            bestPoints: 0,
            time: 0,
            titleButton: "Jugar",
            nameId: "assertiveCommunication",
          },
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/arrobamedellin.appspot.com/o/imageGames%2FgestionEfectivaDelTiempo.png?alt=media&token=4808a689-36d6-4841-827a-85e2a1214e70",
            descriptionImage: "Imagen del juego Gestión efectiva del tiempo",
            title: "Contra el tiempo",
            paragraph:
              "Ayuda a Caspian a cumplir los pendientes que tiene para poder entregar su proyecto a tiempo y no alcance a cruzar el deadline.",
            lesson:
              "Aprende a organizar tus obligaciones para entregarlas a tiempo y alcances una gestión efectiva del mismo.",
            bestPoints: 0,
            time: 0,
            titleButton: "Jugar",
            nameId: "effectiveTimeManagement",
          },
          {
            image:
            "https://firebasestorage.googleapis.com/v0/b/arrobamedellin.appspot.com/o/imageGames%2Fanalisislogico.png?alt=media&token=3c24e5bb-7dd9-4f7b-b0e1-b650e134fb27",
            descriptionImage: "Juego Análisis lógico",
            title: "Enigma",
            paragraph:
              "Desafía tus capacidades de lógica y análisis descifrando los desafíos que se presentan en tu camino.",
            lesson: "Mejora tu desarrollo cognitivo.",
            bestPoints: 0,
            time: 0,
            titleButton: "Descargar",
            gameWebgl:
            "https://firebasestorage.googleapis.com/v0/b/arrobamedellin.appspot.com/o/Games%2FEnigma.zip?alt=media&token=6a06ac10-37e4-4f5d-a5b3-c702151d3aed",
          },
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/arrobamedellin.appspot.com/o/imageGames%2Ftrabajoenequipo.png?alt=media&token=8df7b5eb-b688-4022-b75a-f0763d574ce0",
            descriptionImage: "Imagen  del juego Trabajo en equipo",
            title: "El magnate",
            paragraph:
              "Resuelve los desafíos que encontrarás en el camino junto a tu equipo para que Frost, el dueño de la mansión, los contrate como su equipo de seguridad.",
            lesson:
              "Comprende la importancia de trabajar en equipo en cualquier área de tu vida.",
            bestPoints: 0,
            time: 0,
            titleButton: "Descargar",
            gameWebgl:
              "https://firebasestorage.googleapis.com/v0/b/arrobamedellin.appspot.com/o/Games%2FEl%20Magnate.zip?alt=media&token=ac84c62f-728b-4c23-a1a5-c183aba4e826",
          },
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/arrobamedellin.appspot.com/o/imageGames%2Fhabilidadesdenegociaci%C3%B3n.png?alt=media&token=a8bfd3c1-2255-4b6b-b886-f3e5ad108151",
            descriptionImage: "Imagen del juego Habilidades de negociación",
            title: "Fuga en prisión",
            paragraph:
              "Habla con los reos y conoce qué costo tiene su libertad. Ayúdalos a salir de prisión y gana tu recompensa por el proceso.",
            lesson: "Analiza y construye tus habilidades de negociación.",
            bestPoints: 0,
            time: 0,
            titleButton: "Descargar",
            gameWebgl:
              "https://firebasestorage.googleapis.com/v0/b/arrobamedellin.appspot.com/o/Games%2FFuga%20En%20Prisio%CC%81n.zip?alt=media&token=fe423a1c-6aa6-407a-8f02-fb3e485cec54",
          },
        ],
        count: 5,
      },
      showAgendaModal: false,
      showImageModal: false,
      selectedImage: null,
      agendaItemsToShow: 3,
      agendaEvents: (() => {
        const ctx = require.context(
          "@/assets/img/agenda",
          false,
          /\.(jpg|jpeg|png|gif|webp)$/i
        );
        return ctx
          .keys()
          .map((key) => {
            const filename = key
              .replace("./", "")
              .replace(/\.(jpg|jpeg|png|gif|webp)$/i, "");
            const sep = filename.indexOf("_");
            const date = sep !== -1 ? filename.substring(0, sep) : filename;
            const title = sep !== -1 ? filename.substring(sep + 1) : filename;
            return { date, title, image: ctx(key) };
          })
          .sort((a, b) => {
            const dayA = parseInt(a.date) || -1;
            const dayB = parseInt(b.date) || -1;
            return dayA - dayB;
          });
      })(),
      fiveGames: [],
      pagination: {
        count: 0,
        initial: 0,
        total: 0,
      },
    };
  },
  created() {
    this.find();
  },
  mounted() {
    this.userRole = this.user.role.name;
    this.dataTutorial("entertainment");
    this.updateAgendaItemsToShow();
    window.addEventListener("resize", this.updateAgendaItemsToShow);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateAgendaItemsToShow);
  },
  methods: {
    updateAgendaItemsToShow() {
      if (window.innerWidth < 768) {
        this.agendaItemsToShow = 1;
      } else if (window.innerWidth < 1024) {
        this.agendaItemsToShow = 2;
      } else {
        this.agendaItemsToShow = 3;
      }
    },
    redirectTo(section) {
      this.$router.push({ name: "ComercialStore", params: { section } });
    },
    async find() {
      this.fiveGames = [];
      let result;
      try {
        result = this.games;
        if (this.pagination.initial === 0) {
          this.fiveGames.push(result.data[0], result.data[1]);
          const assertiveCommunication = "assertiveCommunication";
          const gameAssertiveCommunication =
            await commercialService.getScoreAndTimeGame(assertiveCommunication);
          this.fiveGames[0].bestPoints = gameAssertiveCommunication.bestPoints;
          this.fiveGames[0].time = this.secondsToString(
            gameAssertiveCommunication.time
          );
          const effectiveTimeManagement = "effectiveTimeManagement";
          const gameEffectiveTimeManagement =
            await commercialService.getScoreAndTimeGame(
              effectiveTimeManagement
            );
          this.fiveGames[1].bestPoints = gameEffectiveTimeManagement.bestPoints;
          this.fiveGames[1].time = this.secondsToString(
            gameEffectiveTimeManagement.time
          );
        } else if (this.pagination.initial === 1) {
          this.fiveGames.push(result.data[2], result.data[3]);
          const logicalAnalysis = "logicalAnalysis";
          const gameLogicalAnalysis =
            await commercialService.getScoreAndTimeGame(logicalAnalysis);
          this.fiveGames[0].bestPoints = gameLogicalAnalysis.bestPoints;
          this.fiveGames[0].time = this.secondsToString(
            gameLogicalAnalysis.time
          );
          const teamwork = "teamwork";
          const gameTeamwork = await commercialService.getScoreAndTimeGame(
            teamwork
          );
          this.fiveGames[1].bestPoints = gameTeamwork.bestPoints;
          this.fiveGames[1].time = this.secondsToString(gameTeamwork.time);
        } else {
          this.fiveGames.push(result.data[4]);
          const negotiationSkills = "assertiveCommunication";
          const gameNegotiationSkills =
            await commercialService.getScoreAndTimeGame(negotiationSkills);
          this.fiveGames[0].bestPoints = gameNegotiationSkills.bestPoints;
          this.fiveGames[0].time = this.secondsToString(
            gameNegotiationSkills.time
          );
        }
        this.pagination.count = result.count;
        this.pagination.total = Math.ceil(this.pagination.count / 2);
        if (this.fiveGames.length === 0) {
          this.pagination.initial = 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
    secondsToString(seconds) {
      var hour = Math.floor(seconds / 3600);
      hour = hour < 10 ? "0" + hour : hour;
      var minute = Math.floor((seconds / 60) % 60);
      minute = minute < 10 ? "0" + minute : minute;
      var second = seconds % 60;
      second = second < 10 ? "0" + second : second;
      return hour + ":" + minute + ":" + second;
    },
    ir(n) {
      this.pagination.initial = n;
      this.find();
    },
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    roleValidationNoAccess() {
      return [
        "University",
        "AdministratorCall",
        "Entrepreneur",
        "Administrator",
      ].some((a) => a === this.userRole);
    },
  },
};
</script>

<style lang="scss" scoped src="./Commercial.scss"></style>
